import { NodeExtension, ParamType } from 'helicon';

export const SequenceExtension: NodeExtension = {
  type: 'Sequence',
  processor: '/SequenceProcessor.js',
  description: {
    numberOfInputs: 0,
    numberOfOutputs: 1,
    outputChannelCount: [1],
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete',
    params: {
      clock: {
        type: ParamType.AudioParam,
        default: 0,
      },
      reset: {
        type: ParamType.AudioParam,
        default: 0,
      },
      sequence: {
        type: ParamType.Value,
        default: [],
      },
    },
    signals: {
      position: {
        readable: true,
        trigger: true,
        default: 0,
      },
    },
  },
};
